import * as React from 'react'

const Svg = ({fill = "#3879F0"}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M4 12L12 4M4 4L12 12" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)
export default Svg